<template>
  <invoiceList/>
</template>

<script>
import invoiceList from './components/invoiceList'
export default {
  components: {
    invoiceList
  },
  data () {
    return {
      breadCrumbs: [{
        label: '首页'
      }, {
        label: '个人中心'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.myOwnOrder {
    width: 100%;
}
</style>
